import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import MagNumber from 'components/MagNumber'
import { useReduxSelector } from 'store'
import React from 'react'

interface HeaderNumberProps {
  warehouseId: string
}

const HeaderNumber: React.FC<HeaderNumberProps> = ({ warehouseId }) => {
  const { name, isShared, acronym } = useReduxSelector(state => selectWarehouse(state, warehouseId))
  return (
    <div className='shop__wrapper__number'>
      <MagNumber
        number={name}
        isShared={isShared}
        acronym={acronym}
      />
    </div>
  )
}

export default HeaderNumber